// DOCUMENTAR
import React from 'react'
import Text from '../../../../_components/Text';
import Button from "../../../../_components/Button"
import CheckBox from '../../../../_components/Checkbox';
import { Form } from 'react-bootstrap'
import { CreateNFeContext } from './Context';
import NFeModel from './nfe.model'
import {
    decimalFormat,
    setLocalStorageItem,
    getLocalStorageItem,
    deleteLocalStorageItem,
    donwloadBase64,
    showSnackBar,
    getCookieByName,
    callSupport
} from '../../../../utils';

import { toast } from "react-toastify";
import BuyNotesPack from '../../../../views/AppViews/Plans/BuyAdditionalNotes';
import NFeIdentification from './Identification';
import NFeItems from './Items';
import NFePaymentsShipping from './NFePaymentShipping'
import NFeFinish from './NFeFinish';

import NFeConfigs from '../Config';

import testsKey from './test.keys.json'

import StepsFooter from "./components/Steps/Footer"
import Header from "./components/Steps/Header"

import Dialog from './Dialog';
import SweetNFeAuthorized from "./Dialog/NFeAuthorized"
import SweetNFeRejected from "./Dialog/NFeRejeited"

import { getBranchPlan, getBranchInvoices } from '../../../../api/plans';

import {
    createNFe,
    getNFeConfig,
    previewNFe,
    updateNFeConfig,
    filterNFe,
    updateNFeStatus
} from '../../../../api/nfe';

import { adjustPlan } from '../../../../api/plans';
import BuyAdditionalNotes from '../../../../views/AppViews/Plans/BuyAdditionalNotes';

const branch = getCookieByName("branch_owner_id")

export default class NFeIssuer extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            defaultNFe: NFeModel,
            nfe: NFeModel,
            NFeResult: {},
            error: false,
            errorMessage: "",
            currentStep: "nfe-details",
            idIntermed: "",
            sweetAlert: { show: false },
            showModalPendingNotes: false,
            searchingPengingNotes: false,
            sending: false,
            previewing: false,
            showModalNFeConfig: false,
            partOfNFe: false,
            modalNFeAuthorized: false,
            rejected: false,
            message: "",
            downloadingFile: false,
            pendingNotes: { showModal: false, notes: [], loading: false },
            sendMailCheckBox: true,
            createPayInCheckBox: false,
            downloadLinks: {},
            isToggled: false,
            isFinancialAllowed: false,
            adjustModal: false,
            canEmitModalAlmostDue: false,
            canEmitModalDue: false,
        }
        this.NFeActions = {}
        const excludeNames = ['constructor', '_validateIdentification', '_validateItems', '_validateCFOP', '_validatePayments', '_validateSteps', '_saveCurrentStepOnLocalStorage', '_setNFeKeyRefFocus', '_updateTotalNFe', 'showSnackBar', '_setNFeToLocalStorage', '_retrieveNFeFromLocalStorage', '_loadStepFromLocalStorage', '_NFeAuthorized', '_clearNFeStorageData', '_getNFeConfig', 'componentDidMount', 'render']

        const propertyNames = Object.getOwnPropertyNames(Object.getPrototypeOf(this));

        for (const propertyName of propertyNames) {
            if (!excludeNames.includes(propertyName)) {
                this[propertyName] = this[propertyName].bind(this)
                this.NFeActions[propertyName.replace("_", '')] = this[propertyName]
            }
        }
    }



    _updateNFeData(nfe) {
        this.setState({ nfe })

        if (nfe.identification.nat_op != "Venda") {

            this.setState({ createPayInCheckBox: false })
            nfe.create_pay_in_transaction = false
            this.UpdateOtherExpenses()

        }

        setTimeout(() => {
            this._setNFeToLocalStorage()
        }, 300)
    }

    _changeStep(e) {
        let { issuerHeaderStep: currentStep } = e.target.dataset
        const { value } = e.target
        currentStep = currentStep || value
        this.setState({ currentStep })
        this._saveCurrentStepOnLocalStorage(currentStep)
        window.scrollTo({ top: 0 })
    }
    _validateIdentification() {
        const { recipient, ref_key, fin_nfe } = this.state.nfe.identification
        if (!recipient) {
            toast.error("Selecione o Destinatário!", { position: "top-center" })
            return false
        }
        if (fin_nfe !== "1") {
            if (!fin_nfe || !ref_key || (ref_key && ref_key.length < 44)) {
                showSnackBar("A chave de referência deve ter 44 caracteres.")
                this._setNFeKeyRefFocus()
                return false
            }
        }
        const { ind_pres, ind_intermed } = this.state.nfe.identification
        const intermed = parseInt(ind_pres)
        if (intermed >= 2 && ind_intermed === "1") {
            const { cnpj_inter, id_intermed } = this.state.nfe.identification
            if (!cnpj_inter || !id_intermed) {
                showSnackBar("Informe o CNPJ do intermediador e o seu nome de usuário na plataforma de delivery, marketplace e similar.")
                return false
            }
            if (cnpj_inter.length !== 14) {
                showSnackBar("CNPJ do intermediador inválido")
                return false
            }
            if (id_intermed.length < 4) {
                showSnackBar("O nome de usuário na plataforma de delivery é inválido. Quantidade de caracteres inválida.")
                return false
            }
        }
        return true

    }
    _validateItems() {
        if (this.state.nfe.items.length === 0) {
            toast.error("Adicione ao menos um item!", { position: "top-center" })

            return false
        }
        return true
    }
    _validateCFOP() {
        let isValid = []
        const { nfe } = this.state
        const { items } = nfe
        items.map(item => {
            delete item.invalid_cfop
            return item
        })
        const branchStateName = getCookieByName("branch_state_name")
        const clientStateName = this.state.nfe.identification.recipient_state_uf
        const sameState = branchStateName === clientStateName

        for (let x = 0; x < items.length; x++) {
            const item = items[x]
            if (sameState) {
                if (nfe.identification.tp_nf === "0" && !item.cfop_code.startsWith("1")) {
                    item.invalid_cfop = true
                    item.invalid_cfop_message = "Código inválido para venda dentro do estado"
                    item.cfop_suggested = ['1101', '1102']
                    isValid.push(1)
                }
                if (nfe.identification.tp_nf === "1" && !item.cfop_code.startsWith("5")) {
                    item.invalid_cfop = true
                    item.invalid_cfop_message = "Código inválido para venda dentro do estado"
                    item.cfop_suggested = ['5101', '5102']
                    isValid.push(1)
                }
            } else {
                if (nfe.identification.tp_nf === "0" && !item.cfop_code.startsWith("2")) {
                    item.invalid_cfop = true
                    item.invalid_cfop_message = "Código inválido para venda fora do estado"
                    item.cfop_suggested = ['2101', '2102']
                    isValid.push(1)
                }
                if (nfe.identification.tp_nf === "1" && !item.cfop_code.startsWith("6")) {
                    item.invalid_cfop = true
                    item.invalid_cfop_message = "Código inválido para venda fora do estado"
                    item.cfop_suggested = ['6101', '6102']
                    isValid.push(1)
                }
            }

        }
        this.forceUpdate()
        if (isValid.length > 0) {
            showSnackBar("Código de CFOP inválido para alguns items")
        }
        return isValid.length === 0
    }
    _validatePayments() {
        const { fin_nfe, nat_op } = this.state.nfe.identification
        if (fin_nfe != "1") {
            return true
        }
        const clearValue = nat_op.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        if (clearValue.toLowerCase().includes("remessa") || clearValue.toLowerCase().includes("devolucao")) {
            return true
        }
        if (this.state.nfe.payments.length === 0) {
            toast.error("Adicione ao menos um pagamento!", { position: "top-center" })
            return false
        }
        return true
    }
    _stepMove(e) {
        const { moveTo } = e.target.dataset
        let currentStep = this.state.currentStep

        if (moveTo === "next-step") {
            if (this.state.currentStep === "nfe-details") {
                if (!this._validateIdentification()) {
                    return
                }
                currentStep = "items"
            } else if (this.state.currentStep === "items") {
                if (!this._validateItems()) {
                    return
                }
                if (!this._validateCFOP()) {
                    return
                }
                currentStep = "payments-transport"
            } else if (this.state.currentStep === "payments-transport") {
                if (!this._validatePayments()) {
                    return
                }
                currentStep = "finish"
            }

        } else if (moveTo === "pevious-step") {
            if (this.state.currentStep === "finish") {
                currentStep = "payments-transport"
            } else if (this.state.currentStep === "payments-transport") {
                currentStep = "items"
            } else if (this.state.currentStep === "items") {
                currentStep = "nfe-details"
            }
        }

        this.setState({ currentStep })
        this._saveCurrentStepOnLocalStorage(currentStep)
        window.scrollTo({ top: 0 })

    }
    _setStep(step) {
        this.setState({ currentStep: step })
        this._saveCurrentStepOnLocalStorage(step)
        window.scrollTo({ top: 0 })

    }
    _validateSteps() {
        const { nfe } = this.state
        if (nfe.identification.nat_op === "") {
            showSnackBar("Selecione uma natureza de operação")
            return false
        }
        if (!nfe.identification.recipient) {
            showSnackBar("Selecione o destinatário")
            return false
        }
        if (!nfe.items.length) {
            showSnackBar("Adicione pelo menos um item na nota")
            return false
        }
        if (!nfe.transport.shipping) {
            showSnackBar("Adicione pelo menos um pagamento de transporte")
            return false
        }
        return true
    }
    _saveCurrentStepOnLocalStorage(currentStep) {
        setLocalStorageItem("currentStep", currentStep, false)
    }

    _setTpNFe(e) {
        const { value } = e.target
        const { nfe } = this.state
        nfe.identification.tp_nf = value
        this.setState({ nfe })
        this._setNFeToLocalStorage()
    }
    _setFinNF(e) {
        const { value } = e.target
        const { nfe } = this.state
        nfe.identification.fin_nfe = value

        if (value !== "1") {
            nfe.identification.allow_ref_key = true
            nfe.identification.ref_key = ""
            this._setNFeKeyRefFocus()
        } else {
            nfe.identification.allow_ref_key = false
            delete nfe.identification.ref_key
        }
        if (value === "2" || value === "3") {
            nfe.identification.ind_pres = "0"
            nfe.identification.ind_intermed = "0"
            nfe.identification.cnpj_inter = "0"
            nfe.identification.id_intermed = ""
            nfe.identification.allow_intermed_data = false
        }
        this.setState({ nfe })
        this._setNFeToLocalStorage()
    }
    _setNFeKeyRefFocus() {
        setTimeout(() => {
            const { identification } = testsKey
            const rootElement = `${testsKey.rootElement}-${identification.rootElement}`
            const elementId = `${rootElement}-${identification.ref_key}`
            try {
                document.getElementById(elementId).focus()
            } catch (error) { }
        }, 200)
    }
    _addNFeItem(item, stackable) {
        const { nfe } = this.state
        if (!item.fiscal_data.cfop.code) {
            const name = item.sellable.name.substr(0, 60)
            const message = `O item ${name} não possui dados fiscais!`
            showSnackBar(message)
            return
        }
        const knownItem = nfe.items.filter(i => i.id === item.id)[0]
        if (knownItem && !stackable) {
            nfe.items[knownItem.index].quantity += 1
        } else {
            item.quantity = 1
            item.product = item.id
            item.cfop_code = item.fiscal_data.cfop.code
            item.cfop = item.fiscal_data.cfop.code
            item.item_sale_price = item.sellable.price
            nfe.items.push(item)
        }

        let base_value = parseFloat(item.quantity || 1) * parseFloat(item.item_sale_price)
        base_value = decimalFormat(base_value, 3)

        if (!item.icms) {
            let p_icms = item.fiscal_data.template_icms.p_icms || 0
            const v_icms = decimalFormat((p_icms / 100) * base_value, 3)

            const csosn = item.fiscal_data.template_icms.csosn || "102"
            const cst = item.fiscal_data.template_icms.cst || "00"
            item.icms = {
                ...item.fiscal_data.template_icms,
                bc_icms: base_value,
                v_icms
            }
            if (branch.crt === 3) {
                item.icms["cst"] = cst
            } else {
                item.icms["csosn"] = csosn
            }
            /*
            if (["102", "103", "300", "400", "900"].includes(item.fiscal_data.template_icms.csosn)) {
                item.icms = {
                    bc_icms: item.item_sale_price,
                    v_icms: 0,
                    csosn: item.fiscal_data.template_icms.csosn,
                    orig: item.fiscal_data.template_icms.orig
                }
            } else {
                item.icms = { ...item.fiscal_data.template_icms, bc_icms: base_value, v_icms }
            }
            */
        } else {
            item.icms = { ...item.icms, bc_icms: item.icms.bc_icms || 0, v_icms: item.icms.v_icms || 0 }
        }
        if (!item.ipi) {
            if (item.fiscal_data.template_ipi) {
                let p_ipi = item.fiscal_data.template_ipi.p_ipi || 0
                const v_ipi = decimalFormat((p_ipi / 100) * base_value, 3)
                item.ipi = { ...item.fiscal_data.template_ipi, bc_ipi: base_value, v_ipi }
            } else {
                item.ipi = {
                    "cst": "99",
                    "c_enq": "999",
                    "calculo": "0",
                    "p_ipi": 0,
                    "v_ipi": 0,
                    bc_ipi: base_value
                }
            }
        }
        if (!item.pis) {
            if (item.fiscal_data.template_pis) {
                let p_pis = item.fiscal_data.template_pis.p_pis || 0
                const v_pis = decimalFormat((p_pis / 100) * base_value, 3)
                item.pis = { ...item.fiscal_data.template_pis, v_pis }
            } else {
                item.pis = {
                    "cst": "99",
                    "calculo": 0,
                    "p_pis": 0,
                    "v_pis": 0,
                    bc_pis: base_value
                }
            }
        }
        if (!item.cofins) {
            if (item.fiscal_data.template_cofins) {
                let p_cofins = item.fiscal_data.template_cofins.p_cofins || 0
                const v_cofins = decimalFormat((p_cofins / 100) * base_value, 3)
                item.cofins = { ...item.fiscal_data.template_cofins, v_cofins }
            } else {
                item.cofins = {
                    cst: "99",
                    bc_cofins: 0,
                    p_cofins: 0,
                    v_cofins: 0,
                }
            }
        }
        nfe.payments = []
        nfe.total_nfe = 0
        nfe.total_paid = 0

        this.setState({ nfe })
        this._updateTotalNFe()

        setTimeout(() => {
            this._validateCFOP()
        }, 250)
    }
    _removeNFeItem(trash) {
        const { nfe } = this.state
        const items = nfe.items.filter(item => item.id !== trash.id)
        nfe.items = items
        nfe.payments = []
        nfe.total_nfe = 0
        nfe.total_paid = 0
        this.setState({ nfe })
        this._updateTotalNFe()
    }
    _updateNFeItem(item, index, updateFiscalTax = false) {
        const { nfe } = this.state
        item.quantity = decimalFormat(item.quantity, 6)
        nfe.items[index] = { ...item }
        if (updateFiscalTax) {
            let base_value = parseFloat(nfe.items[index].quantity || 1) * parseFloat(nfe.items[index].item_sale_price)
            base_value = decimalFormat(base_value, 3)

            let p_icms = item.icms.p_icms || 0
            const v_icms = decimalFormat((p_icms / 100) * base_value, 3)
            nfe.items[index].icms = {
                ...item.icms,
                bc_icms: base_value,
                v_icms
            }

            let p_ipi = item.ipi.p_ipi || 0
            const v_ipi = decimalFormat((p_ipi / 100) * base_value, 3)
            nfe.items[index].ipi = {
                ...item.ipi,
                bc_ipi: base_value,
                v_ipi
            }

            let p_pis = item.pis.p_pis || 0
            const v_pis = decimalFormat((p_pis / 100) * base_value, 3)
            nfe.items[index].pis = {
                ...item.pis,
                bc_pis: base_value,
                v_pis
            }
            let p_cofins = item.cofins.p_cofins || 0
            const v_cofins = decimalFormat((p_cofins / 100) * base_value, 3)
            nfe.items[index].cofins = {
                ...item.cofins,
                bc_cofins: base_value,
                v_cofins
            }
        }
        nfe.payments = []
        nfe.total_nfe = 0
        nfe.total_paid = 0
        this.setState({ nfe })
        this._updateTotalNFe()
        this._validateCFOP()
    }
    _updateTotalNFe() {
        const { nfe } = this.state
        let { shipping_value, other_expenses, transport } = nfe
        nfe.total_nfe = 0
        let total_nfe = nfe.items.reduce((total, item) => {
            return total + (decimalFormat(item.quantity) * decimalFormat(item.item_sale_price))
        }, 0)
        nfe.total_items = decimalFormat(total_nfe)
        if (transport.mod_frete === 9) {
            shipping_value = 0
        }
        total_nfe += decimalFormat(shipping_value, 4)
        total_nfe += decimalFormat(other_expenses, 4)
        nfe.total_nfe = total_nfe.toFixed(4)
        nfe.paid_value = (nfe.total_nfe - this.state.nfe.identification.discount_value) - nfe.total_paid
        this.setState({ nfe })
        this._setNFeToLocalStorage()
    }
    updateTotalNFe() {
        this._updateTotalNFe()
    }
    _addPayment(payment) {
        const { nfe } = this.state
        nfe.payments.push(payment)
        nfe.total_paid = nfe.payments.reduce((acc, cur) => acc + cur.value, 0)

        const left = nfe.total_nfe - (nfe.total_paid + nfe.identification.discount_value)
        nfe.paid_value = left < 0 ? 0 : left

        this.setState({ nfe })
        this._setNFeToLocalStorage()
    }
    _setNFePayments(payments) {
        const { nfe } = this.state
        nfe["payments"] = payments
        nfe.total_paid = nfe.payments.reduce((acc, cur) => acc + cur.value, 0)
        nfe.paid_value = nfe.total_nfe - nfe.total_paid
        this.setState({ nfe })
        this._setNFeToLocalStorage()
    }
    _setPaidValue(value) {
        const { nfe } = this.state
        nfe.paid_value = value
        this.setState({ nfe })
        this._setNFeToLocalStorage()
    }
    _setDiscount(value) {
        const { nfe } = this.state
        if (value > nfe.total_nfe) {
            nfe.identification.discount_value = nfe.total_nfe
        }
        else {
            nfe.identification.discount_value = value
        }

        this.setState({ nfe })
        this._setNFeToLocalStorage()
    }
    _removePayment(payment) {
        const { nfe } = this.state
        nfe.payments = nfe.payments.filter((item, index) => payment.index !== index)
        nfe.total_paid = nfe.payments.reduce((acc, cur) => acc + cur.value, 0)

        const left = nfe.total_nfe - (nfe.total_paid + nfe.identification.discount_value)
        nfe.paid_value = left < 0 ? 0 : left

        this.setState({ nfe })
        this._setNFeToLocalStorage()
    }
    _setNFeTransportShipping(e) {
        const { value } = e.target
        const { nfe } = this.state
        nfe.transport.mod_frete = value
        if (value === "9") {
            nfe.volumes = []
            nfe.shipping_value = "0"
            delete nfe.transporter
        }
        this.setState({ nfe })
        this._setNFeToLocalStorage()
        this._updateTotalNFe()
    }
    _addTransporter(transporter) {
        transporter.city_location = transporter.city_location.id
        const { nfe } = this.state
        nfe["transporter"] = transporter
        this.setState({ nfe })
        this._setNFeToLocalStorage()
    }
    _removeTransporter() {
        const { nfe } = this.state
        delete nfe.transporter
        this.setState({ nfe })
        this._setNFeToLocalStorage()
    }
    _addShippingValue(shippingValue) {
        const { nfe } = this.state
        nfe.shipping_value = shippingValue
        this.setState({ nfe })
        this._updateTotalNFe()
        this._setNFeToLocalStorage()
    }
    _otherExpensesValue(value) {
        const { nfe } = this.state
        nfe.other_expenses = value
        this.setState({ nfe })
        this._updateTotalNFe()
        this._setNFeToLocalStorage()
    }
    _addVolume(volume) {
        const { nfe } = this.state
        nfe.volumes.push(volume)
        nfe.volumes = nfe.volumes.reverse()
        this.setState({ nfe })
        this._setNFeToLocalStorage()
    }
    _removeVolume(index) {
        const { nfe } = this.state
        const volumes = nfe.volumes.filter((item, i) => i !== index)
        nfe.volumes = volumes
        this.setState({ nfe })
        this._setNFeToLocalStorage()
    }
    openModalSearchPendingNotes() { }
    _setNFeToLocalStorage() {
        setLocalStorageItem("nfe", this.state.nfe)
    }
    validateCFOP() {
        this._validateCFOP()
    }
    _retrieveNFeFromLocalStorage() {
        const nfe = getLocalStorageItem("nfe")
        if (nfe) {
            this.setState({ nfe })
            this._validateCFOP()
        }
    }
    _loadStepFromLocalStorage() {
        const currentStep = getLocalStorageItem("currentStep", false)
        if (currentStep) {
            this.setState({ currentStep })
        }
    }


    _checkAndResolvePendingBeforeSend() {
        console.log("[CHECK] Iniciando checagem de notas pendentes...");
        return getNFeConfig()
            .then((configData) => {
                const serie = configData.nfe_serie;
                const currentNumber = parseInt(configData.nfe_number, 10) || 0;

                const windowStart = Math.max(1, currentNumber - 50);
                const windowEnd = currentNumber + 1;

                return filterNFe({
                    series: serie,
                    status: 6,
                    start_number: windowStart,
                    end_number: windowEnd,
                    end_count: 10,
                    ordering: "-number",
                }).then((pendentesJanela) => {
                    if (Array.isArray(pendentesJanela) && pendentesJanela.length > 0) {
                        return pendentesJanela;
                    }
                    return filterNFe({
                        series: serie,
                        status: 6,
                        end_count: 1,
                        ordering: "-updated_at",
                    });
                });
            })
            .then((pendentes) => {
                const apenasPendentes = (Array.isArray(pendentes) ? pendentes : [])
                    .map(n => ({ ...n, _status: Number(n.status) }))
                    .filter(n => n._status === 6);

                const pendente = apenasPendentes.length ? apenasPendentes[0] : null;

                if (!pendente) {
                    console.log("[CHECK] Nenhuma NF-e pendente (status 6) encontrada.");
                    this.setState({ pendingWasConsulted: false });
                    return true;
                }

                console.log("[CHECK] NF-e pendente (status 6) encontrada:", pendente);

                this.setState({
                    sending: true,
                    sendingTitle: "Consultando NF-e pendente na SEFAZ...",
                });

                return updateNFeStatus(pendente.id)
                    .then(() => {
                        console.log("[CHECK] Consulta da pendente concluída com sucesso.");
                        this.setState({ pendingWasConsulted: true });
                    })
                    .catch((err) => {
                        console.error("[CHECK] Erro ao consultar pendente:", err);
                    })
                    .then(() => {
                        this.setState({ sending: false, sendingTitle: "" });
                        return false;
                    });
            })
            .catch((e) => {
                console.error("[CHECK] Falha durante checagem:", e);
                return true;
            });
    }



    _sendNFe(preview = false) {
        if (!this._validateIdentification()) {
            this.setState({ currentStep: "nfe-details" });
            return;
        }
        if (!this._validateItems()) {
            this.setState({ currentStep: "items" });
            return;
        }
        if (!this._validateCFOP()) {
            this.setState({ currentStep: "items" });
            return;
        }
        if (!this._validatePayments()) {
            this.setState({ currentStep: "payments-transport" });
            return;
        }

        return this._checkAndResolvePendingBeforeSend()
            .then((canProceed) => {
                if (!canProceed) {
                    this.setState({ sending: false, sendingTitle: "" });
                    toast.info(
                        "Existe uma NF-e pendente na SEFAZ. Já realizamos a consulta. Aguarde a regularização antes de tentar emitir novamente.",
                        { position: "top-center" }
                    );
                    return Promise.reject(new Error("Emissão bloqueada por NF-e pendente."));
                }

                if (this.state.pendingWasConsulted) {
                    toast.success(
                        "Encontramos uma NF-e pendente e já consultamos na SEFAZ. Tente emitir novamente.",
                        { position: "top-center" }
                    );
                    this.setState({ pendingWasConsulted: false });
                }

                const { nfe } = this.state;
                let payments = nfe.payments.map((pay) => {
                    pay.value = decimalFormat(pay.value, 2);
                    return pay;
                });
                nfe.payments = payments;

                nfe.items = nfe.items.filter((item) => {
                    if (item.pis === "") {
                        delete item.pis;
                    }
                    if (item.cofins === "") {
                        delete item.cofins;
                    }
                    return item;
                });

                let request = {};

                if (preview === true) {
                    this.setState({ sending: true, sendingTitle: "Gerando prévia da DANFE" });
                    request = previewNFe(nfe).then((data) => this._previewCallback(data));
                } else {
                    this.setState({ sending: true, sendingTitle: "Emitindo NF-e ..." });
                    request = createNFe(nfe).then((data) => {
                        this.setState({
                            nfe: {
                                ...this.state.nfe,
                                id: data.id,
                                key: data.key,
                            },
                            sending: false,
                            modalNFeAuthorized: true,
                        });
                    });
                }

                return request.catch((error) => {
                    this.setState({ sending: false, rejected: false, message: "" });
                    const data = error.data;

                    if (!(data === undefined) && data.plan_error) {
                        this.setState({
                            error: true,
                            errorMessage: (
                                <div>
                                    <Text className="h4" color="primary">
                                        Seu plano de notas está vencido, clique no botão abaixo para acessar as suas faturas
                                    </Text>
                                    <a
                                        href="/plan/branch-invoices"
                                        className="btn btn-primary btn-sm block"
                                    > Ver faturas </a>
                                </div>
                            )
                        });
                        return;
                    }

                    if (error.doc_description) {
                        this.setState({
                            ...this,
                            rejected: true,
                            message: error.doc_description
                        });
                        return;
                    }

                    if (error.nfe_dup_error) {
                        this.setState({
                            sending: true,
                            sendingTitle:
                                "Nota com essa numeração já foi autorizada ou está pendente. Consultando última situação na SEFAZ...",
                        });

                        getNFeConfig().then(async (configData) => {
                            const currentNumber = parseInt(configData.nfe_number);
                            const serie = configData.nfe_serie;

                            const allNFe = await filterNFe({
                                series: serie,
                                end_count: 1000,
                                ordering: "-number",
                            });

                            let maxNumber = currentNumber;
                            if (Array.isArray(allNFe) && allNFe.length > 0) {
                                const nums = allNFe
                                    .map(n => parseInt(n.number))
                                    .filter(n => !isNaN(n));
                                if (nums.length) {
                                    maxNumber = Math.max(...nums, currentNumber);
                                }
                            }

                            const pendentes = await filterNFe({
                                start_number: Math.min(currentNumber, maxNumber),
                                end_number: Math.max(currentNumber, maxNumber),
                                series: serie,
                                end_count: 1000,
                                ordering: "-number",
                            });

                            const pendente = Array.isArray(pendentes) && pendentes.length > 0
                                ? pendentes.find(p => Number(p.status) === 6) || null
                                : null;

                            if (pendente) {
                                updateNFeStatus(pendente.id)
                                    .then(() => {
                                        this.setState({ sending: false, sendingTitle: "", pendingWasConsulted: true });
                                        toast.info(
                                            "Existe uma NF-e pendente. Já realizamos a consulta, aguarde a regularização antes de emitir novamente.",
                                            { position: "top-center" }
                                        );
                                    })
                                    .catch((err2) => {
                                        this.setState({ sending: false, sendingTitle: "" });
                                        toast.error(
                                            (err2 && err2.error) || "Falha ao consultar a nota na SEFAZ.",
                                            { position: "top-center" }
                                        );
                                    });

                                return;
                            }

                            this.setState({ sending: false, sendingTitle: "" });
                            toast.error(
                                "Não foi possível ajustar automaticamente a numeração. Verifique sua última nota emitida.",
                                { position: "top-center" }
                            );
                        });

                        return;
                    }

                    if (error.max_free_nf_value_error) {
                        this.setState({
                            error: true,
                            errorMessage: (
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                    <Text color="primary" className="text-center pb-4">
                                        Não é permitido emitir NF-e com valor maior que R$ 2.500,00 no plano gratuito.
                                    </Text>
                                    <Button onClick={() => {
                                        this.setState({ ...this, error: false, errorMessage: "" })
                                        const btn = document.getElementById("a3b5f732-871e-5d64-b430-a89c12d5a1f8")
                                        if (btn) btn.click()
                                    }}>
                                        Comprar notas adicionais
                                    </Button>
                                </div>
                            )
                        });
                        return;
                    }

                    if (error.internal_error) {
                        const support = () => callSupport("[Erro 500] Preciso falar com o suporte, por gentileza.")

                        this.setState({
                            error: true,
                            errorMessage: <div>
                                <Text className="h4 py-3" color="primary">
                                    Ops...
                                </Text>
                                <Text className="h5" color="primary">
                                    Erro 500: Para analisarmos melhor o problema, acione o suporte pelo nosso chat. <Button as="text" className="text-info" onClick={support}>Clique aqui</Button>
                                </Text>
                                <Text className="h6">
                                    {error.internal_error}
                                </Text>
                            </div>
                        });
                        return;
                    }

                    if (!(data === undefined) && data.invoice_pending) {
                        this.setState({
                            error: true,
                            errorMessage: (
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                    <Text color="primary" className="text-center pb-4">
                                        Você atingiu o limite de notas para este plano, por favor,
                                        entre em contato com o suporte para mais informações.
                                        Ou clique no botão abaixo para adquirir notas adicionais.
                                    </Text>

                                    <Button onClick={() => {
                                        this.setState({ ...this, error: false, errorMessage: "" })
                                        const btn = document.getElementById("a3b5f732-871e-5d64-b430-a89c12d5a1f8")
                                        if (btn) btn.click()
                                    }}>
                                        Comprar notas adicionais
                                    </Button>
                                </div>
                            )
                        });
                        return;
                    }

                    if (!(data === undefined) && data.notes_overflowed_limit) {
                        this.setState({
                            error: true,
                            errorMessage: (
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                    <Text color="primary" className="text-center pb-4">
                                        Você atingiu o limite de notas para este plano, por favor,
                                        entre em contato com o suporte para mais informações.
                                        Ou clique no botão abaixo para adquirir notas adicionais.
                                    </Text>
                                    <Button onClick={() => {
                                        this.setState({ ...this, error: false, errorMessage: "" })
                                        const btn = document.getElementById("a3b5f732-871e-5d64-b430-a89c12d5a1f8")
                                        if (btn) btn.click()
                                    }}>
                                        Comprar notas adicionais
                                    </Button>
                                </div>
                            )
                        });
                        return;
                    }

                    if (!data) {
                        let errors = [];
                        Object.keys(error).map(section => {
                            if (section == 'non_field_errors') {
                                error.non_field_errors.map(item => errors.push(item))
                            } else {
                                if (Array.isArray(error[section])) {
                                    error[section].map(item => {
                                        if (Array.isArray(item)) {
                                            errors.push(`${section}: ${item[0]}`)
                                        } else {
                                            errors.push(`${section}: ${item.value}`)
                                        }
                                    })
                                }
                            }
                        });
                        this.setState({
                            error: true,
                            errorMessage: <div>
                                <Text as="h3">{error.doc_description}</Text>
                                {
                                    errors.map((_error, index) => {
                                        return <Text key={`can-send-nfe-error-id-${index}`}>{_error}</Text>
                                    })
                                }
                            </div>
                        });
                        return;
                    }
                    else {
                        this.setState({ adjustModal: true })

                        adjustPlan()
                            .then(() => { })
                            .catch(() => { })
                    }

                });
            })
            .catch(err => {
                console.error("Falha na checagem antes de enviar", err);
            });
    }





    _previewCallback(response) {
        const fileName = `preview_${response.series}_${response.number}`
        donwloadBase64(fileName, 'pdf', `application/pdf`, response.pdf64_encoded)
        this.setState({ sending: false, sendingTitle: "" })
    }
    _clearNFeStorageData() {
        deleteLocalStorageItem("currentStep")
        deleteLocalStorageItem("nfe")
        this.setState({ ...this, currentStep: "nfe-details", nfe: NFeModel })
        window.location.reload()

    }
    async _getNFeConfig() {
        getNFeConfig()
            .then(data => {
                const { nfe } = this.state
                nfe.id = data.id
                nfe.identification.fat_number = data.nfe_number
                nfe.identification.fisco_information = data.nfe_fisco_information
                nfe.identification.serie = data.nfe_serie
                nfe.send_danfe_to_client = data.send_danfe_to_client
                nfe.create_pay_in_transaction = data.create_pay_in_transaction

                this.setState({ sendMailCheckBox: nfe.send_danfe_to_client })
                this.setState({ createPayInCheckBox: nfe.create_pay_in_transaction })
                this.setState({ nfe })
                //this._updateNFeConfig(nfe)
                this._setNFeToLocalStorage()
                try {
                    document.querySelector('[data-nfe-config-number]').textContent = data.nfe_number
                    document.querySelector('[data-nfe-config-serie]').textContent = data.nfe_serie

                } catch (error) {

                }
            })
            .catch(err => { })
    }
    _openModalNFeConfig() {
        this.setState({ showModalNFeConfig: true })
    }
    _closeModalNFeConfig() {
        this.setState({ showModalNFeConfig: false })
        this._getNFeConfig()
    }
    async _init() {
        this._getNFeConfig()
    }
    componentDidMount() {


        getBranchPlan().then(resp => {
            if (resp.plan == 'b85046a1-3803-4ee4-a858-8ef2c26d9d76' || resp.plan == '3c38ed4a-d8a2-4766-8f22-12fd6fec6ec0') {
                this.setState({ isFinancialAllowed: true })
            }
            else {
                this.setState({ isFinancialAllowed: false, createPayInCheckBox: false })
            }
        })

        getBranchInvoices().then(resp => {
            if (resp && resp.some(item => {
                if (item.status !== 1 || item.description.includes("Pacote")) return false;
                const [d, m, y] = item.due_date.split("/").map(Number);
                const due = new Date(y, m - 1, d), now = new Date();
                return now >= due && now <= new Date(due.getTime() + 5 * 86400000);
            })) {
                this.setState({ canEmitModalAlmostDue: true });
            }
        });

        getBranchInvoices().then(resp => {
            if (resp && resp.some(item => {
                if (item.status !== 1 || item.description.includes("Pacote")) return false;
                const [d, m, y] = item.due_date.split("/").map(Number);
                const due = new Date(y, m - 1, d), now = new Date();
                return now > new Date(due.getTime() + 5 * 86400000);
            })) {
                this.setState({ canEmitModalDue: true });
            }
        });



        window.scrollTo({ top: 0, behavior: "smooth" })
        // TODO: Verificar se a empresa tem IE
        setTimeout(() => {
            this._loadStepFromLocalStorage()
            this._retrieveNFeFromLocalStorage()
            this._init()
        }, 300)
    }

    _updateNFeConfig(data) {
        updateNFeConfig(data)
            .then(resp => {
                this._updateLocalStorage()
                console.log(resp)
            })
    }

    UpdateOtherExpenses() {
        getNFeConfig()
            .then(data => {
                const configObj = {}
                configObj.id = data.id
                configObj.send_danfe_to_client = this.state.sendMailCheckBox
                configObj.create_pay_in_transaction = this.state.createPayInCheckBox
                configObj.nfce_fisco_information = data.nfce_fisco_information
                configObj.nfe_fisco_information = data.nfe_fisco_information
                configObj.nfe_number = data.nfe_number
                configObj.nfe_serie = data.nfe_serie
                configObj.nfe_danfe_orientation = data.nfe_danfe_orientation
                configObj.nfce_number = data.nfce_number
                configObj.nfce_serie = data.nfce_serie
                configObj.nfce_danfe_orientation = data.nfce_danfe_orientation
                configObj.add_xml_auth = data.add_xml_auth

                this._updateNFeConfig(configObj)

            })
            .catch(err => { })
    }

    handleToggle = () => {
        this.setState(prevState => ({
            isToggled: !prevState.isToggled
        }));
    }

    render() {
        return <CreateNFeContext.Provider
            value={{
                "nfe": this.state.nfe || NFeModel,
                "handlers": this.NFeActions,
                "step": this.state.currentStep
            }} >
            <div
                id={testsKey.rootElement}
                className="container-fluid" >
                <div id="nfe-issuer-div-buy-additional-notes" className="d-none">
                    <BuyNotesPack id="nfe-issuer-button-buy-additional-notes" />
                </div>
                <NFeConfigs />

                <div className='mb-3 row '>
                    <CheckBox
                        onClick={() => {
                            const { nfe } = this.state

                            if (this.state.sendMailCheckBox == true) {
                                this.setState({ sendMailCheckBox: false })
                                nfe.send_danfe_to_client = false
                                this.setState({ nfe })
                                this.UpdateOtherExpenses()
                                this._setNFeToLocalStorage()
                            }
                            else {
                                this.setState({ sendMailCheckBox: true })
                                nfe.send_danfe_to_client = true
                                this.setState({ nfe })
                                this.UpdateOtherExpenses()
                                this._setNFeToLocalStorage()
                            }
                        }}
                        checked={this.state.sendMailCheckBox}
                        label="Enviar NF-e para o email do Destinatário"
                    />

                    {this.state.isFinancialAllowed && this.state.nfe.identification.nat_op == "Venda" ?

                        <CheckBox
                            onClick={() => {
                                const { nfe } = this.state

                                if (this.state.createPayInCheckBox == true) {
                                    this.setState({ createPayInCheckBox: false })
                                    nfe.create_pay_in_transaction = false
                                    this.setState({ nfe })
                                    this.UpdateOtherExpenses()
                                    this._setNFeToLocalStorage()
                                }
                                else {
                                    this.setState({ createPayInCheckBox: true })
                                    nfe.create_pay_in_transaction = true
                                    this.setState({ nfe })
                                    this.UpdateOtherExpenses()
                                    this._setNFeToLocalStorage()
                                }
                            }}
                            checked={this.state.createPayInCheckBox}
                            label="Criar Conta a Receber ao emitir NF-e"
                            className="ml-3"
                        />

                        :
                        <React.Fragment />
                    }



                    <Form.Check
                        className="ml-3"
                        type="switch"
                        id="toggle"
                        label={this.state.isToggled ? <Text className="form-label" >Emissão simplificada</Text> : <Text className="form-label" >Emissão padrão</Text>}
                        checked={this.state.isToggled}
                        onClick={this.handleToggle}
                    />


                </div>

                <div>
                    <div
                        id="buy-additional-notes"
                        className="d-none">
                        <BuyNotesPack />
                        <BuyAdditionalNotes forceVisible />
                    </div>

                    <Dialog
                        onHide={() => this.setState({ canEmitModalDue: false })}
                        show={this.state.canEmitModalDue}
                        title="Atenção"
                        type="error"
                        hideClose
                    >
                        <Text>
                            Você possui uma fatura em aberto e o prazo de 5 dias após o vencimento para emitir notas acabou! Emissão bloqueada. Regularize o quanto antes para evitar multas e juros de seu plano.                        </Text>
                        <Button onClick={() => {

                            window.location.href = "/plan/branch-invoices"
                        }

                        }>Ver Faturas</Button>
                    </Dialog>

                    <Dialog
                        onHide={() => this.setState({ canEmitModalAlmostDue: false })}
                        show={this.state.canEmitModalAlmostDue}
                        title="Pagamento pendente"
                        type="warning"
                    >
                        <Text>
Você possui uma fatura em aberto e o prazo máximo é de 5 dias após o vencimento para regularizar. Evite bloqueio, multas e juros de seu plano, realizando o pagamento o quanto antes.
                        </Text>
                        <Button onClick={() => {

                            window.location.href = "/plan/branch-invoices"
                        }

                        }>Ver Faturas</Button>

                    </Dialog>


                    <Dialog
                        textButton
                        onHide={() => {

                            this.setState({ ...this, adjustModal: false })
                            window.location.reload()

                        }}
                        show={this.state.adjustModal}
                        title={'Ocorreu um erro inesperado.'}
                        type="warning"></Dialog>

                    <Dialog
                        onHide={() => this.setState({ ...this, error: false, errorMessage: "" })}
                        disabled={this.state.sending}
                        show={this.state.error}
                        title=""
                        type="error">
                        {
                            this.state.errorMessage
                        }
                    </Dialog>

                    <Dialog
                        disabled={this.state.sending}
                        show={this.state.sending}
                        title={this.state.sendingTitle}
                        type="none">
                        <p className="text-center h4 mt-4">
                            <i class="fas fa-spinner fa-pulse fa-2x" />
                        </p>
                    </Dialog>
                    <SweetNFeRejected
                        show={this.state.rejected}
                        message={this.state.message} />
                    <SweetNFeAuthorized
                        nfe={this.state.nfe}
                        show={this.state.modalNFeAuthorized} />
                    <Header />
                    <NFeIdentification simplified={this.state.isToggled} />
                    <NFeItems />
                    <NFePaymentsShipping />
                    <NFeFinish />
                    <hr />
                    <StepsFooter />
                </div>
                {/* Verificar se existe uma nota em andamento */}
            </div>
            {/* Verificar se existe notas pendentes de consulta */}
        </CreateNFeContext.Provider >
    }
}


// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/index.jsx